import { sessionStorageProxy, SessionStorageKeys } from "../services";
import { useNavigate } from "react-router-dom";
import { useMount } from "@sportal/cdk/hooks";

export const useRestoreSession = () => {
  const navigate = useNavigate();

  useMount(() => {
    const oldUrl = sessionStorageProxy.getItem(SessionStorageKeys.ExpiredUrl);

    if (oldUrl) {
      navigate(oldUrl, { replace: true });

      sessionStorageProxy.removeItem(SessionStorageKeys.ExpiredUrl);
    }
  });
};
